import React from "react";
import { IDefaultPagesProps } from "../../interfaces/Lms";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const addCommentFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Organization", "orgs/list-borrower-orgs", { required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Special Purpose Entity", "orgs/list-spes", { dependencyField: "organizationId" })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Category", "orgs/list-comment-categories", { name: "organizationCommentCategoryId", required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Subject", { required: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Comments", { required: true,  name: "description" })]);
  return myForm;
};

const AddCommentForm = () => {
  const myForm = addCommentFields(new BCFormController({}, { submitSuffix: "orgs/comment" }));
  const formActions = ["save-new", "save-close", "close"];

  return <LmsFormGenerator myForm={myForm} actions={formActions}/>;
};

const ViewCommentForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`orgs/comment/${id}`);
  const myForm = addCommentFields(new BCFormController(data, { submitSuffix: "orgs/comment", initIsDisabled: true }));

  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={["close"]}/>;
};

const LmsOrganizationsBorrowerOrgComments = ({ ...props }: IDefaultPagesProps) => {
  const { params = {}, history } = props;
  const allowedActions = ["add"];
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params, allowedActions);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <LmsTable
      actionButtons={["add", "export", "archive"]}
      apiSuffix="orgs/comments"
      archiveSuffix="orgs/archive-comments"
      sortable={["Created On"]}
      columnLabelsDictionary={{ organizationCommentCategory: "Category", description: "Comments" }}
    />}
    {isAdd && <AddCommentForm/>}
    {isEdit && <ViewCommentForm id={id}/>}
  </React.Fragment>;
};

export default LmsOrganizationsBorrowerOrgComments;